import { render, staticRenderFns } from "./PoQuestionnaire.vue?vue&type=template&id=0f266fb0"
import script from "./PoQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./PoQuestionnaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports